const BaseApi = "https://jobs.needtoday.com/apis/api"

export default BaseApi
